import { find } from './dom';

/** Mobile menu toggle + close-on-navigation. */
export function initNav(): void {
  const toggle = find<HTMLButtonElement>('menuToggle');
  const menu = find('mobileMenu');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('mobile-menu--open');
    toggle.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  });

  menu.addEventListener('click', (e) => {
    if ((e.target as HTMLElement).closest('a')) {
      menu.classList.remove('mobile-menu--open');
      document.body.style.overflow = '';
    }
  });
}
